import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import IconButton from '../Button/IconButton.js';
import { StyledTag } from '../MetaCRMTag/MetaCRMTag.styles.js';
import { SIZE } from '../constants/inputConstants.js';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledAutoCompleteContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1wq4cnu5"
})(_ref => {
  return {
    '& *': {
      fontFamily: "'Inter', sans-serif, 'Noto Sans CJK TC', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4'"
    },
    ' ul': {
      padding: 0,
      margin: 0
    }
  };
}, "");
const StyledAutoComplete = /*#__PURE__*/_styled(Autocomplete, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1wq4cnu4"
})(_ref2 => {
  let {
    theme,
    size = SIZE.XL,
    isTag,
    hasError,
    noBorder,
    focusBorderWidth,
    isShowBorderError
  } = _ref2;
  return {
    '& .MuiInputBase-root': _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      padding: 0,
      paddingLeft: '9px',
      paddingTop: '2px',
      paddingBottom: '2px',
      color: theme.customColors.grey[700]
    }, size === SIZE.XL && {
      minHeight: '40px'
    }), size === SIZE.LARGE && {
      minHeight: '36px'
    }), size === SIZE.MEDIUM && {
      minHeight: '32px'
    }), size === SIZE.SMALL && {
      minHeight: '28px',
      fontSize: '12px',
      '&.MuiInputBase-sizeSmall': {
        paddingBottom: '3px',
        paddingTop: '3px',
        paddingLeft: '10px'
      },
      [StyledTag]: {
        height: '18px',
        margin: '1px 2px'
      }
    }), size === SIZE.XS && {
      height: '24px',
      fontSize: '12px',
      paddingLeft: '10px',
      [StyledTag]: {
        height: '16px',
        margin: '1px 2px'
      }
    }), {}, {
      '& .MuiAutocomplete-input': _objectSpread2({
        padding: '3.5px 4px 3.5px 5px',
        lineHeight: 2
      }, size === SIZE.XS && {
        padding: '1.5px 4px 1.5px 5px'
      })
    }, hasError && {
      background: theme.customColors.pink[100],
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.customColors.pink[600]
      }
    }), {}, {
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': _objectSpread2({
          borderColor: hasError && isShowBorderError ? theme.customColors.pink[600] : theme.customColors.purple[500]
        }, noBorder && {
          borderColor: 'transparent'
        })
      },
      '& span.MuiAutocomplete-tag': _objectSpread2({}, isTag && _objectSpread2(_objectSpread2({
        background: theme.customColors.purple[300],
        borderRadius: '3px',
        padding: '0px 5px',
        height: '20px'
      }, size === SIZE.SMALL && {
        height: '18px',
        margin: '1px 2px'
      }), size === SIZE.XS && {
        height: '16px',
        margin: '1px 2px'
      }))
    }),
    '& .MuiOutlinedInput-notchedOutline': _objectSpread2({
      border: "1px solid ".concat(theme.customColors.grey[300])
    }, noBorder && {
      // border: 'none',
      borderColor: 'transparent'
    }),
    '& .MuiOutlinedInput-root': {
      background: theme.customColors.white,
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: hasError && isShowBorderError ? theme.customColors.pink[600] : theme.customColors.purple[500],
          borderWidth: focusBorderWidth
        }
      }
    }
  };
}, "");
const StyledAutoCompleteTextField = /*#__PURE__*/_styled(TextField, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1wq4cnu3"
})(_ref3 => {
  let {
    theme,
    isSelect,
    noBorder
  } = _ref3;
  return _objectSpread2(_objectSpread2({
    '& .MuiInputBase-input': {
      '&::placeholder': {
        color: theme.customColors.grey[500],
        opacity: 1
      }
    }
  }, isSelect && {
    '&  .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: "".concat(theme.customColors.grey[700], " !important"),
      caretColor: 'transparent !important',
      cursor: 'pointer !important'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: "".concat(theme.customColors.grey[300], " !important")
    }
  }), isSelect && noBorder && {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent !important'
    },
    '&.Mui-disabled': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent !important'
      }
    }
  });
}, "");
const StyledCustomPaper = /*#__PURE__*/_styled(Paper, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1wq4cnu2"
})(_ref4 => {
  let {
    theme,
    isTag,
    onHandleOption
  } = _ref4;
  return {
    '& .MuiAutocomplete-listbox': _objectSpread2(_objectSpread2({}, isTag && {
      paddingTop: 0
    }), {}, {
      '& .MuiAutocomplete-option[aria-selected=true]': {
        backgroundColor: 'transparent',
        '&.Mui-focused': {
          backgroundColor: '#FCFAFF'
        }
      },
      '& .MuiAutocomplete-option': {
        '&:hover': {
          backgroundColor: '#FCFAFF'
        },
        '&.Mui-focused': {
          backgroundColor: '#FCFAFF'
        }
      }
    })
  };
}, "");
const StyledSelectItemMoreBtn = /*#__PURE__*/_styled(IconButton, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1wq4cnu1"
})(_ref5 => {
  return {};
}, "");
export { StyledAutoComplete, StyledAutoCompleteContainer, StyledAutoCompleteTextField, StyledCustomPaper, StyledSelectItemMoreBtn };